export default "__VITE_ASSET__8b54f78a__"